<div [ngClass]="{ 'row':true, 'mb-3':hint === undefined, 'mb-2':hint !== undefined}">
  <div class="col-6 col-md-5">
    <span>
      {{ label }}
    </span>
    @if (tooltipOverLabel) {
      <ucs-icon [shape]="'info'" [class]="'blue'" [size]="18"
                [floatUi]="tooltipOverLabel" [showTrigger]="NgxFloatUiTriggers.hover"></ucs-icon>
    }
  </div>
  <div class="col-5" [ngClass]="{'d-flex justify-content-between':showGrossPriceInfo}">
    <div class="price">
      @if (ucsIsNil(netPrice)) {
        {{ '-' }}
      } @else {
        <span class="float-left">{{ currency }}</span>
        <span class="float-right">
          {{ netPrice | price: undefined : undefined :  '1.2-2' }}
          @if (showNet) {
            {{ 'api.type.pricetype.NET' | translate }}
          }
        </span>
      }
    </div>
    @if (showGrossPriceInfo) {
      <div class="price" [floatUi]="popGrossPriceTooltip"
           [showTrigger]="NgxFloatUiTriggers.hover" [placement]="NgxFloatUiPlacements.RIGHT"
           [disabled]="ucsIsNil(grossPriceTooltip)">
        @if (ucsIsNil(grossPrice)) {
          {{ '-' }}
        } @else {
          <span class="float-left">{{ currency }}</span>
          <span class="float-right">
            {{ grossPrice | price: undefined : undefined :  '1.2-2' }}
            {{ 'api.type.pricetype.GROSS' | translate }}
          </span>
        }
      </div>
      <float-ui-content class="float-ui-content-display gross-price-tooltip" #popGrossPriceTooltip>
        <div>
          {{ grossPriceTooltip }}
        </div>
      </float-ui-content>
    }
  </div>
  @if (sumIncalculable) {
    <div>
      <ucs-icon [shape]="'alert-triangle'" [size]="18"
                [class]="'grey'"></ucs-icon>
      {{ 'label-price.sum-incalculable' | translate }}
    </div>
  }
</div>
@if (hint !== undefined) {
  <div class="row mb-3 hint">
    <div class="col-12">
      {{ hint }}
    </div>
  </div>
}

